import { httpClient } from "@/lib/http-client"
import { Feature } from "@/lib/models"

export interface AttachmentDetails {
  id: string
  filename: string
  url: string
  size: number
}

export interface NewFeatureRequest extends Feature {
  siteId: string
}

export class FeatureService {
  private static readonly BASE_PATH = "/api/features"

  static async createFeature(feature: NewFeatureRequest): Promise<Feature> {
    return httpClient.post<Feature>(`${this.BASE_PATH}`, feature)
  }

  static async updateFeature(featureId: string, feature: Feature): Promise<Feature> {
    return httpClient.put<Feature>(`${this.BASE_PATH}/${featureId}`, feature)
  }

  static async delete(featureId: string): Promise<void> {
    return httpClient.delete<void>(`${this.BASE_PATH}/${featureId}`)
  }

  static async getByFeatureIds(featureIds: string[]): Promise<Feature[]> {
    return httpClient.post<Feature[]>(`${this.BASE_PATH}/id`, featureIds)
  }

  static async getById(featureId: string): Promise<Feature> {
    return httpClient.get<Feature>(`${this.BASE_PATH}/${featureId}`)
  }

  static async getBySiteId(siteId: string): Promise<Feature[]> {
    return httpClient.get<Feature[]>(`${this.BASE_PATH}/site/${siteId}`)
  }

  static async getByAreaId(areaId: string): Promise<Feature[]> {
    return httpClient.get<Feature[]>(`${this.BASE_PATH}/area/${areaId}`)
  }

  static async getByFeatureTypeId(featureTypeId: string): Promise<Feature[]> {
    return httpClient.get<Feature[]>(`${this.BASE_PATH}/featuretypes/${featureTypeId}`)
  }
}
